import React, { useEffect, createElement } from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { IncludesSection } from '../components/IncludesSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CtaBanner } from '../components/CtaBanner';
import { Footer } from '../components/Footer';
const META_PIXEL_ID = '1421502962259206';
export function LandingPage() {
  useEffect(() => {
    // Inject noscript fallback img
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.insertBefore(noscript, document.body.firstChild);
    // Inject fbevents.js script
    if (document.getElementById('fb-pixel-script')) return;
    const script = document.createElement('script');
    script.id = 'fb-pixel-script';
    script.async = true;
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${META_PIXEL_ID}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
  }, []);
  return <div className="w-full min-h-screen" data-id="element-269">
      <Navbar data-id="element-270" />
      <main data-id="element-271">
        <HeroSection data-id="element-272" />
        <IncludesSection data-id="element-273" />
        <BenefitsSection data-id="element-274" />
        <PricingSection data-id="element-275" />
        <TestimonialsSection data-id="element-276" />
        <CtaBanner data-id="element-277" />
      </main>
      <Footer data-id="element-278" />
    </div>;
}